import {connect} from "react-redux";
import CreditLimitLedger from "./CreditLimitLedgerListing";
import {bindActionCreators} from "redux";
import {
  getLedger
} from "../../../services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
    pendingListing: state.MaterialRequistionForm.creditLimitLedger,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
          getLedger
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CreditLimitLedger);
